export const Article = () => {
  return (
    <>
      <h1>test</h1>
      <article>
        <h2>react</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nisi
          mollitia sapiente inventore numquam voluptate nulla quos fugit
          architecto nesciunt quas dolores illo quae, suscipit alias quia iusto
          enim delectus neque.
        </p>
      </article>
    </>
  );
};
